import { render, staticRenderFns } from "./CookiesSetting.vue?vue&type=template&id=1a1660da&"
import script from "./CookiesSetting.vue?vue&type=script&lang=js&"
export * from "./CookiesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports